import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'modal-assign',
    templateUrl: '../../templates/partials/modal-assign.html'
})

export class ModalAssignComponent implements OnInit {
    @Input() showModal;
    @Input() recurrency = 'none';
    @Output() emitCloseModal = new EventEmitter();
    @ViewChild('assignModal') public assignModal:ModalDirective;
    
    constructor(private _fb: FormBuilder) { }

    public onHidden():void {
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public closeModal():void{
        this.emitCloseModal.emit({action:"close", data: null});
    }

    public unAssign(type: String) {
        (type == "all") ? this.emitCloseModal.emit({action:"close", data: "unAssignAll"}) : this.emitCloseModal.emit({action:"close", data: "unAssign"});
    }

    ngOnChanges(value) {
        (this.showModal) ? this.assignModal.show() : this.assignModal.hide();
    }

    ngOnInit() {}
}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/modal-assign.component.ts